module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "schedule"
  }, [_c('div', {
    staticClass: "panelheader"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.pageName))])]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "lg": {
        span: 18
      },
      "md": {
        span: 18
      },
      "sm": {
        span: 24
      },
      "xs": {
        span: 24
      }
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.schedulerLoading),
      expression: "schedulerLoading"
    }],
    staticClass: "scheduler-container",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "dhx_cal_container centered",
    staticStyle: {
      "width": "90%",
      "height": "95%",
      "margin": "0 auto"
    },
    attrs: {
      "id": "scheduler"
    }
  }, [_c('div', {
    staticClass: "dhx_cal_navline"
  }, [_c('div', {
    staticClass: "dhx_cal_prev_button"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "dhx_cal_next_button"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "dhx_cal_date"
  }), _vm._v(" "), _c('div', {
    staticClass: "dhx_cal_tab",
    staticStyle: {
      "right": "204px"
    },
    attrs: {
      "name": "day_tab"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dhx_cal_tab",
    staticStyle: {
      "right": "140px"
    },
    attrs: {
      "name": "week_tab"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dhx_cal_tab",
    staticStyle: {
      "right": "76px"
    },
    attrs: {
      "name": "month_tab"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dhx_cal_header"
  }), _vm._v(" "), _c('div', {
    staticClass: "dhx_cal_data"
  })])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": {
        span: 6
      },
      "md": {
        span: 6
      },
      "sm": {
        span: 24
      },
      "xs": {
        span: 24
      }
    }
  }, [_c('div', {
    staticClass: "scheduler-list"
  }, [_c('div', {
    staticClass: "site-select"
  }, [_c('div', [_vm._v("Select a site")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Select",
      "no-data-text": "No Sites"
    },
    model: {
      value: (_vm.site),
      callback: function($$v) {
        _vm.site = $$v
      },
      expression: "site"
    }
  }, _vm._l((_vm.sites), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), (_vm.site) ? _c('el-table', {
    ref: "fieldSelectTable",
    staticClass: "site-table",
    staticStyle: {
      "width": "95%"
    },
    attrs: {
      "highlight-current-row": "",
      "data": _vm.fields,
      "empty-text": "No Fields"
    },
    on: {
      "row-click": _vm.handleFieldClick,
      "current-change": _vm.handleCurrentChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Fields"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('div', {
          staticClass: "field-selector"
        }, [_c('span', {
          staticClass: "name"
        }, [_vm._v(_vm._s(props.row.field_name))]), _vm._v(" "), _c('span', {
          staticClass: "colourBox",
          style: ({
            'background-color': props.row.colour
          })
        })])]
      }
    }])
  })], 1) : _vm._e()], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "scheduler_modal",
    attrs: {
      "title": "Schedule",
      "visible": _vm.dialogVisible,
      "width": "65%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.lightboxLoading),
      expression: "lightboxLoading"
    }],
    attrs: {
      "element-loading-text": _vm.loadingText
    }
  }, [_c('el-form', {
    ref: "booking",
    attrs: {
      "rules": _vm.validators,
      "id": "custom_form",
      "model": _vm.booking,
      "label-width": "180px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Club",
      "prop": "club_id"
    }
  }, [_c('el-select', {
    attrs: {
      "name": "club_id"
    },
    model: {
      value: (_vm.booking.club_id),
      callback: function($$v) {
        _vm.$set(_vm.booking, "club_id", $$v)
      },
      expression: "booking.club_id"
    }
  }, _vm._l((_vm.clubs), function(club) {
    return _c('el-option', {
      key: club.id,
      attrs: {
        "value": club.id,
        "label": club.name
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Title (optional)",
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Give booking a name?",
      "name": "title"
    },
    model: {
      value: (_vm.booking.title),
      callback: function($$v) {
        _vm.$set(_vm.booking, "title", $$v)
      },
      expression: "booking.title"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "From",
      "prop": "time"
    }
  }, [_c('el-time-select', {
    staticClass: "time-from",
    attrs: {
      "placeholder": "Start time",
      "editable": false,
      "picker-options": {
        start: '08:30',
        step: '00:15',
        end: '23:59',
        maxTime: _vm.booking.end_time
      }
    },
    model: {
      value: (_vm.booking.start_time),
      callback: function($$v) {
        _vm.$set(_vm.booking, "start_time", $$v)
      },
      expression: "booking.start_time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "To",
      "prop": "time"
    }
  }, [_c('el-time-select', {
    staticClass: "time-to",
    attrs: {
      "placeholder": "End time",
      "editable": false,
      "picker-options": {
        start: '08:30',
        step: '00:15',
        end: '23:59',
        minTime: _vm.booking.start_time
      }
    },
    model: {
      value: (_vm.booking.end_time),
      callback: function($$v) {
        _vm.$set(_vm.booking, "end_time", $$v)
      },
      expression: "booking.end_time"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.fieldsLabel,
      "prop": "field_ids"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, _vm._l((_vm.selObjs), function(sel) {
    return _c('el-select', {
      key: sel,
      attrs: {
        "placeholder": "Select a field",
        "no-data-text": "No Fields"
      },
      model: {
        value: (_vm.booking.field_ids[sel]),
        callback: function($$v) {
          _vm.$set(_vm.booking.field_ids, sel, $$v)
        },
        expression: "booking.field_ids[sel]"
      }
    }, _vm._l((_vm.fields), function(item) {
      return (item.id > -1) ? _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.field_name,
          "value": item.id,
          "disabled": item.disabled
        }
      }) : _vm._e()
    }))
  })), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [(!_vm.updatingBooking && _vm.booking.field_ids.length && _vm.fields.length !== _vm.fields.filter(function (v) { return v.disabled; }).length) ? _c('el-button', {
    staticStyle: {
      "position": "absolute",
      "bottom": "0"
    },
    attrs: {
      "type": "save"
    },
    on: {
      "click": _vm.handleFieldAddClick
    }
  }, [_vm._v("\n                    +\n                  ")]) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1,
      "offset": 2
    }
  }, [(_vm.booking.field_ids.length > 1) ? _c('el-button', {
    staticStyle: {
      "position": "absolute",
      "bottom": "0"
    },
    attrs: {
      "type": "cancel"
    },
    on: {
      "click": _vm.handleFieldRemClick
    }
  }, [_vm._v("\n                    -\n                  ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.booking.field_ids.length > 1) ? _c('el-form-item', {
    attrs: {
      "label": "Select scenes",
      "prop": "scene_id"
    }
  }, [_c('el-select', {
    attrs: {
      "name": "scene_select",
      "multiple": "",
      "placeholder": "Select scenes",
      "no-data-text": "No Scenes",
      "disabled": _vm.sceneDisabled
    },
    model: {
      value: (_vm.booking.scene_ids),
      callback: function($$v) {
        _vm.$set(_vm.booking, "scene_ids", $$v)
      },
      expression: "booking.scene_ids"
    }
  }, _vm._l((_vm.scenes), function(item) {
    return _c('el-option', {
      key: item.scene_id,
      attrs: {
        "label": item.scene_name,
        "value": item.scene_id,
        "disabled": item.disabled
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(item.scene_name))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "color": "#8492a6",
        "font-size": "80%"
      }
    }, [_vm._v(_vm._s(item.field_name))])])
  }))], 1) : _c('el-form-item', {
    attrs: {
      "label": "Select scene",
      "prop": "scene_id"
    }
  }, [_c('el-select', {
    attrs: {
      "name": "scene_select",
      "placeholder": "Select scene",
      "no-data-text": "No Scenes",
      "disabled": _vm.sceneDisabled
    },
    model: {
      value: (_vm.booking.scene_ids[0]),
      callback: function($$v) {
        _vm.$set(_vm.booking.scene_ids, 0, $$v)
      },
      expression: "booking.scene_ids[0]"
    }
  }, _vm._l((_vm.scenes), function(item) {
    return _c('el-option', {
      key: item.scene_id,
      attrs: {
        "label": item.scene_name,
        "value": item.scene_id
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(item.scene_name))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "color": "#8492a6",
        "font-size": "80%"
      }
    }, [_vm._v(_vm._s(item.field_name))])])
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.updatingBooking) ? _c('div', [(_vm.recurringIds[_vm.eventId]) ? _c('el-form-item', {
    attrs: {
      "label": "Update recurring?",
      "prop": "updateRecurring"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.alsoUpdateRecurring),
      callback: function($$v) {
        _vm.alsoUpdateRecurring = $$v
      },
      expression: "alsoUpdateRecurring"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("This booking")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("This and following bookings")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("All bookings")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.alsoUpdateRecurring) ? _c('div', {
    staticStyle: {
      "padding-bottom": "8px"
    }
  }, [_vm._v("\n                Updating " + _vm._s(_vm.recurringCount) + " bookings.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.alsoUpdateRecurring) ? _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "Fequency"
    },
    model: {
      value: (_vm.recurringFreq),
      callback: function($$v) {
        _vm.recurringFreq = $$v
      },
      expression: "recurringFreq"
    }
  }, _vm._l((_vm.recurringFreqs), function(freq) {
    return _c('el-option', {
      key: freq.name,
      attrs: {
        "label": freq.name,
        "value": freq.id
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.alsoUpdateRecurring && _vm.recurringFreq > 1) ? _c('div', {
    staticClass: "dayOptWrapper"
  }, [_c('el-checkbox-group', {
    attrs: {
      "size": "medium",
      "prop": "recurringDays"
    },
    model: {
      value: (_vm.recurringDays),
      callback: function($$v) {
        _vm.recurringDays = $$v
      },
      expression: "recurringDays"
    }
  }, _vm._l((_vm.dayOptions), function(day) {
    return _c('el-checkbox-button', {
      key: day.id,
      attrs: {
        "label": day.id
      }
    }, [_vm._v(_vm._s(day.name))])
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.alsoUpdateRecurring) ? _c('div', {
    staticClass: "endDateWrapper"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Start From",
      "prop": "recurringStart"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "placeholder": "Select a start date"
    },
    model: {
      value: (_vm.recurringStart),
      callback: function($$v) {
        _vm.recurringStart = $$v
      },
      expression: "recurringStart"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "End date",
      "prop": "recurringEnd"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "placeholder": "Select an end date",
      "picker-options": _vm.recurringEndOptions
    },
    model: {
      value: (_vm.recurringEnd),
      callback: function($$v) {
        _vm.recurringEnd = $$v
      },
      expression: "recurringEnd"
    }
  })], 1)], 1) : _vm._e()], 1) : _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Recurring Bookings?",
      "prop": "recurringBookings"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Fequency"
    },
    model: {
      value: (_vm.recurringFreq),
      callback: function($$v) {
        _vm.recurringFreq = $$v
      },
      expression: "recurringFreq"
    }
  }, _vm._l((_vm.recurringFreqs), function(freq) {
    return _c('el-option', {
      key: freq.name,
      attrs: {
        "label": freq.name,
        "value": freq.id
      }
    })
  }))], 1), _vm._v(" "), (_vm.recurringFreq > 1) ? _c('div', {
    staticClass: "dayOptWrapper"
  }, [_c('el-checkbox-group', {
    attrs: {
      "size": "medium",
      "prop": "recurringDays"
    },
    model: {
      value: (_vm.recurringDays),
      callback: function($$v) {
        _vm.recurringDays = $$v
      },
      expression: "recurringDays"
    }
  }, _vm._l((_vm.dayOptions), function(day) {
    return _c('el-checkbox-button', {
      key: day.id,
      attrs: {
        "label": day.id
      }
    }, [_vm._v(_vm._s(day.name))])
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.recurringFreq) ? _c('div', {
    staticClass: "endDateWrapper"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Start From",
      "prop": "recurringStart"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "placeholder": "Select a start date"
    },
    model: {
      value: (_vm.recurringStart),
      callback: function($$v) {
        _vm.recurringStart = $$v
      },
      expression: "recurringStart"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "End date",
      "prop": "recurringEnd"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "placeholder": "Select an end date",
      "picker-options": _vm.recurringEndOptions
    },
    model: {
      value: (_vm.recurringEnd),
      callback: function($$v) {
        _vm.recurringEnd = $$v
      },
      expression: "recurringEnd"
    }
  })], 1)], 1) : _vm._e()], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('span', {
    attrs: {
      "disabled": _vm.recurringFreq && !_vm.recurringEnd
    }
  }, [_c('el-button', {
    staticClass: "save-btn",
    attrs: {
      "type": "save"
    },
    on: {
      "click": _vm.save_form
    }
  }, [_vm._v("Save")])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "cancel-btn",
    attrs: {
      "type": "cancel"
    },
    on: {
      "click": _vm.close_form
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.updatingBooking) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.startDelete(_vm.eventId)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e()], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.showDeleteConfirm,
      "width": "50%"
    },
    on: {
      "update:visible": function($event) {
        _vm.showDeleteConfirm = $event
      }
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.deleting),
      expression: "deleting"
    }]
  }, [_c('h3', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n        Delete booking?\n      ")]), _vm._v(" "), _c('div', [_vm._v("Are you sure you wish to delete this booking?")]), _vm._v(" "), _c('div', [_vm._v("This is "), _c('strong', [_vm._v("permanent")]), _vm._v(" and can't be undone")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.recurringIds[_vm.deleteId]) ? _c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "Delete all recurring after this?"
    }
  }, [_c('el-switch', {
    staticStyle: {
      "float": "left",
      "padding": "5px"
    },
    attrs: {
      "active-color": "#FF0000",
      "active-text": "",
      "inactive-text": ""
    },
    model: {
      value: (_vm.deleteRecurring),
      callback: function($$v) {
        _vm.deleteRecurring = $$v
      },
      expression: "deleteRecurring"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDeleteConfirm = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": _vm.deleting
    },
    on: {
      "click": _vm.doDelete
    }
  }, [_vm._v("Delete")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dcae1cae","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Scheduler.vue
// module id = 914
// module chunks = 3